
<div class="p-4 space-y-4 h-screen pb-14 flex-1 overflow-y-auto">
  <div class="grid grid-cols-12 gap-5 max-w-6xl">
      <div *ngIf="companyDetail" class="col-span-12 bg-white shadow dark:lg:bg-zinc-950 ring-1 ring-zinc-200 dark:ring-white/5 rounded-lg divide-y divide-zinc-200 dark:divide-white/5">
          <div class="md:flex justify-between items-center p-4 space-y-4 md:space-y-0">
              <div class="sm:flex items-center sm:space-x-4 space-y-2 sm:space-y-0">
                  <div class="h-20 w-20 ring-1 ring-zinc-200 dark:ring-white/5 flex-shrink-0 rounded-full overflow-hidden">
                      <!-- <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                          <path
                              d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg> -->
                      <img src="{{companyDetail.profileImageURL ? companyDetail.profileImageURL : 'assets/images/company-placeholder.png' }}" alt="profile" class="object-cover w-full h-full">
                  </div>
                  <div>
                      <div class="font-semibold text-base-dark">
                          {{(companyDetail.name) | titlecase}}
                      </div>
                      <div class="text-sm-light">
                          {{companyDetail.email}}
                      </div>
                  </div>
              </div>
              <!-- <div class="flex">
                  <button (click)="openCompanyOverview((companyDetail))" class="btn btn-secondary">
                    Company Overview
                  </button>
              </div> -->
            <span [ngClass]="companyDetail?.isActive ? 'badge-success' : 'badge-danger'">
                {{ companyDetail?.isActive ? 'Active' : 'Inactive' }}
            </span>
          </div>
          <div class="p-4 grid grid-cols-12 gap-4">
              <div class="col-span-12 md:col-span-6">
                  <div class="space-y-1">
                      <div class="text-sm text-base-dark font-medium">
                          Contact Number
                      </div>
                      <div class="text-sm-light" phoneNumberFormat [phoneNumber]="companyDetail?.phoneNumber">
                          {{companyDetail?.phoneNumber}}
                      </div>
                  </div>
              </div>
              <div class="col-span-12 md:col-span-6">
                  <div class="space-y-1">
                      <div class="text-sm text-base-dark font-medium">
                          Address
                      </div>
                      <div class="text-sm-light">
                          {{companyDetail.address.name}}
                      </div>
                  </div>
              </div>
              <div class="col-span-12 md:col-span-6">
                  <div class="space-y-1">
                      <div class="text-sm text-base-dark font-medium">
                          Time Zone
                      </div>
                      <div class="text-sm-light">
                          {{companyDetail.timeZone}}
                      </div>
                  </div>
              </div>
              <div class="col-span-12 md:col-span-6">
                  <div class="space-y-1">
                      <div class="text-sm text-base-dark font-medium">
                          State
                      </div>
                      <div class="text-sm-light">
                          {{(companyDetail.address?.state) | titlecase}}
                      </div>
                  </div>
              </div>
              <!-- <div class="col-span-12 md:col-span-6">
                  <div class="space-y-1">
                      <div class="text-sm text-zinc-500 dark:text-zinc-400 font-medium">
                          Web Address
                      </div>
                      <div class="text-sm text-zinc-500 dark:text-zinc-400">
                          www.medextrans.com
                      </div>
                  </div>
              </div> -->
          </div>
      </div>
    <div *ngIf="companyWiseConfiguration" class="col-span-12 bg-white shadow dark:lg:bg-zinc-950 
                ring-1 ring-zinc-200 dark:ring-white/5 
                rounded-lg divide-y divide-zinc-200 dark:divide-white/5">
    
        <div class="md:flex justify-between items-center p-4 space-y-4 md:space-y-0">
            <h2 class="heading">
                Configuration
            </h2>
            <span [ngClass]="companyWiseConfiguration?.isActive ? 'badge-success' : 'badge-danger'">
                {{ companyWiseConfiguration?.isActive ? 'Active' : 'Inactive' }}
            </span>
        </div>
    
        <div class="p-4 grid grid-cols-12 gap-4">
    
            <!-- Reference -->
            <div class="col-span-12 md:col-span-6">
                <div class="space-y-1">
                    <div class="text-sm text-base-dark font-medium">
                        Reference
                    </div>
                    <div class="text-sm-light w-full block truncate">
                        {{ companyWiseConfiguration.reference }}
                    </div>
                </div>
            </div>
    
            <!-- General Url -->
            <div class="col-span-12 md:col-span-6">
                <div class="space-y-1">
                    <div class="text-sm text-base-dark font-medium">
                        General Url
                    </div>
                    <div class="text-sm-light w-full block truncate" >
                        {{ companyWiseConfiguration.generalUrl }}
                    </div>
                </div>
            </div>

            <!-- Driver Url -->
            <div class="col-span-12 md:col-span-6">
                <div class="space-y-1">
                    <div class="text-sm text-base-dark font-medium">
                        Driver Url
                    </div>
                    <div class="text-sm-light w-full block truncate" >
                        {{ companyWiseConfiguration.driverUrl }}
                    </div>
                </div>
            </div>
    
            <!-- Vehicle Url -->
            <div class="col-span-12 md:col-span-6">
                <div class="space-y-1">
                    <div class="text-sm text-base-dark font-medium">
                        Vehicle Url
                    </div>
                    <div class="text-sm-light w-full block truncate">
                        {{ companyWiseConfiguration.vehicleUrl }}
                    </div>
                </div>
            </div>

    
        </div>
    </div>

      <div [routerLink]="['/drivers']" class="col-span-12 sm:col-span-6 bg-white shadow dark:lg:bg-zinc-950 ring-1 ring-zinc-200 dark:ring-white/5 rounded-lg p-4 cursor-pointer">
          <div class="flex justify-between items-center">
              <div
                  class="h-16 w-16 ring-1 ring-zinc-200 dark:ring-white/5 flex flex-shrink-0 shadow justify-center items-center rounded-full">
                  <svg class="w-10 h-10 text-zinc-950 dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z">
                      </path>
                  </svg>
              </div>
              <div class="flex flex-col items-center">
                  <div class="text-6xl font-bold text-zinc-950 dark:text-white">
                      {{driverCount || 0}}
                  </div>
                  <div class="text-xl font-medium text-zinc-500 dark:text-zinc-400">
                      Drivers
                  </div>
              </div>
          </div>
      </div>
      <div [routerLink]="['/vehicles']" class="col-span-12 sm:col-span-6 bg-white shadow dark:lg:bg-zinc-950 ring-1 ring-zinc-200 dark:ring-white/5 rounded-lg p-4 cursor-pointer">
          <div class="flex justify-between items-center">
              <div
                  class="h-16 w-16 ring-1 ring-zinc-200 dark:ring-white/5 flex flex-shrink-0 shadow justify-center items-center rounded-full">
                  <svg class="devfont devfont-jeep w-10 h-10 text-zinc-950 dark:text-white" xmlns="http://www.w3.org/2000/svg"
                      width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M7 16v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3"></path>
                      <path d="M21 16H3V9l1-5h16l1 5v7z"></path>
                      <path d="M2 9h20"></path>
                      <path d="M7 12.375h.01"></path>
                      <path d="M17 12.375h.01"></path>
                      <path d="M10.5 16v-4"></path>
                      <path d="M13.5 16v-4"></path>
                      <path d="M21 16v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3"></path>
                  </svg>
              </div>
              <div class="flex flex-col items-center">
                  <div class="text-6xl font-bold text-zinc-950 dark:text-white">
                      {{vehicleCount || 0}}
                  </div>
                  <div class="text-xl font-medium text-zinc-500 dark:text-zinc-400">
                      Vehicles
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

<app-signup-details-slideout *ngIf="companyObj" [signUpdetailObj]="companyObj" [drivers]="driverCount" [vehicles]="vehicleCount" (closeModal)="companyObj = null"></app-signup-details-slideout>
